export const styles = {
  titleHolder: {
    paddingTop: 2,
  },
  title: {
    color: "primary.main",
    letterSpacing: ".1rem",
  },
};
